import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import BillerCenter from '../../screens/BillerCenter'
import { documentTitle } from '../../static/Routes'

const Stack = createStackNavigator()
const PgProduct = React.lazy(() => import('../../screens/PgProduct'))
const SeamlessPay = React.lazy(() => import('../../screens/Products'))
const PaymentGateway = React.lazy(() => import('../../screens/PaymentGateway'))
const Pos = React.lazy(() => import('../../screens/Pos'))
const UpiHub = React.lazy(() => import('../../screens/UpiHub'))

export const ProductSectionStack = () => {
  return (
    <>
      <Stack.Screen
        name={'paymentgateway'}
        component={PaymentGateway}
        options={{
          title: 'PaymentGateWay',
        }}
      />
      <Stack.Screen
        name={'pointofsale'}
        component={() => <Pos />}
        options={{
          title: 'Point Of Sale',
        }}
      />
      <Stack.Screen
        name={'upi'}
        component={UpiHub}
        options={{
          title: 'UPI Hub',
        }}
      />
      <Stack.Screen
        name={'biller'}
        component={BillerCenter}
        options={{
          title: 'Biller Center',
        }}
      />
      <Stack.Screen
        name={'direct'}
        component={Direct}
        options={{
          title: documentTitle.paydirect,
        }}
      />
      <Stack.Screen
        name={'repeat'}
        component={Repeat}
        options={{
          title: documentTitle.payrepeat,
        }}
      />
      <Stack.Screen
        name={'collect'}
        component={Collect}
        options={{
          title: documentTitle.paycollect,
        }}
      />
      <Stack.Screen
        name={'campaign'}
        component={Campaign}
        options={{
          title: documentTitle.paycampaign,
        }}
      />
      <Stack.Screen
        name={'mobile-checkout'}
        component={MobileCheckout}
        options={{
          title: documentTitle.mobileCheckout,
        }}
      />
      <Stack.Screen
        name={'vault'}
        component={Vault}
        options={{
          title: documentTitle.vault,
        }}
      />
      <Stack.Screen
        name={'console'}
        component={Console}
        options={{
          title: documentTitle.console,
        }}
      />
      <Stack.Screen
        name={'oneqr'}
        component={OneQR}
        options={{
          title: documentTitle.oneqr,
        }}
      />
      <Stack.Screen
        name={'products'}
        component={SeamlessPay}
        options={{
          title: documentTitle.products,
        }}
      />
      <Stack.Screen
        name={'voicebox'}
        component={VoiceBox}
        options={{
          title: documentTitle.voicebox,
        }}
      />
      <Stack.Screen
        name={'voicebox-qr'}
        component={VoiceBox}
        options={{
          title: documentTitle.voicebox,
        }}
      />
      <Stack.Screen
        name={'packagingbox-qr'}
        component={VoiceBox}
        options={{
          title: documentTitle.voicebox,
        }}
      />
    </>
  )
}

const Direct = () => <PgProduct id="paydirect" />

const Repeat = ()=> <PgProduct id="payrepeat" />

const Collect = () => <PgProduct id="paycollect" />

const Campaign = () => <PgProduct id="paycampaign" />

const MobileCheckout = () => <PgProduct id="mobileCheckout" />

const Vault = () => <PgProduct id="vault" />

const Console = () => <PgProduct id="console" />

const OneQR = () => <PgProduct id="oneqr" />

const VoiceBox = () => <PgProduct id="voicebox" />
